import HttpRequestService from "./HttpRequestService";

const RatingService = {};

const cntrlName = "GetUserRatings";

//API for get all data
RatingService.getRatingList = function () {
  return HttpRequestService.get(`${cntrlName}?id=0`);
};

RatingService.submitRating = function (body) {
  return HttpRequestService.post("UpsertRating", body);
};

export default RatingService;
